import React from 'react';
import { AppLocaleProvider } from 'sd-ui-components';
const { FormattedNumber } = AppLocaleProvider;

export default class ScorePercentage extends React.Component {
  render() {
    const { value } = this.props;
    let { wholeNumber } = this.props;
    let ltOne = false;
    let parsedValue = isNaN(parseFloat(value))
      ? 0.0
      : parseFloat(value) / 100.0;

    if (parsedValue < 0.01) {
      parsedValue = 0.01;
      wholeNumber = true;
      ltOne = true;
    }

    return (
      <span>
        {ltOne && '< '}
        <FormattedNumber
          // eslint-disable-next-line
          style="percent"
          value={parsedValue}
          maximumFractionDigits={wholeNumber ? 0 : 2}
        />
      </span>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/Common/ScorePercentage.jsx